module.exports = "pegasus/assets/styleGroup3-twitter.png";